import React, { FC } from 'react';
import styled from 'styled-components';
import { ContainerBase } from 'src/components/widgets/layouts';
import { SkeletonBlock, SkeletonStack } from 'src/components/widgets/skeleton';

// Mirrors the FiltersRow the page renders above the charts (same gap and bottom margin).
const Row = styled.div`
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
    flex-wrap: wrap;
`;

const Charts = styled.div`
    display: flex;
    gap: 16px;
    margin-bottom: 24px;
    flex-wrap: wrap;
`;

export const AnalyticsBodySkeleton: FC = () => (
    <>
        <Charts>
            <SkeletonBlock $width='48%' $height='350px' $radius='6px' />
            <SkeletonBlock $width='48%' $height='350px' $radius='6px' />
        </Charts>
        <SkeletonBlock $width='100%' $height='240px' $radius='6px' />
    </>
);

export const DamAnalyticsPageSkeleton: FC = () => (
    <ContainerBase>
        <SkeletonStack $gap='10px' $margin='0 0 24px'>
            <SkeletonBlock $width='160px' $height='28px' />
            <SkeletonBlock $width='50%' $height='14px' />
        </SkeletonStack>
        <Row>
            <SkeletonBlock $width='60px' $height='32px' $radius='6px' />
            <SkeletonBlock $width='100px' $height='32px' $radius='6px' />
            <SkeletonBlock $width='100px' $height='32px' $radius='6px' />
            <SkeletonBlock $width='100px' $height='32px' $radius='6px' />
        </Row>
        <AnalyticsBodySkeleton />
    </ContainerBase>
);

export default DamAnalyticsPageSkeleton;
